/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import castArray from 'lodash/castArray';
import isArray from 'lodash/isArray';
import type { GraphQLError } from 'graphql';

// Sets the error message on this error according to the
// the GraphQL errors that are present.
const generateErrorMessage = (err: GraphQLErrors) => {
	let message = '';
	// If we have GraphQL errors present, add that to the error message.
	if (isArray(err.graphQLErrors) && err.graphQLErrors.length > 0) {
		err.graphQLErrors.forEach((graphQLError: GraphQLError) => {
			const errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
			message += `${errorMessage}\n`;
		});
	}

	// strip newline from the end of the message
	message = message.replace(/\n$/, '');
	return message;
};

/**
 * @deprecated This package is deprecated and no longer actively maintained.
 */
export class GraphQLErrors extends Error {
	public message: string;

	public graphQLErrors: ReadonlyArray<GraphQLError>;

	public cause: GraphQLError;

	public statusCode: number;

	public errorType: string | null;

	constructor(graphQLErrors?: GraphQLError | ReadonlyArray<GraphQLError>) {
		super();

		this.graphQLErrors = graphQLErrors != null ? castArray(graphQLErrors) : [];
		this.message = generateErrorMessage(this);
		this.cause = this.graphQLErrors?.[0];
		this.statusCode =
			this.cause?.extensions?.statusCode ?? this.cause?.extensions?.[0]?.statusCode ?? -1;
		this.errorType =
			this.cause?.extensions?.errorType ?? this.cause?.extensions?.[0]?.errorType ?? null;
	}
}
